import React from 'react';
import { observer } from 'mobx-react-lite';
import Grid from '@material-ui/core/Grid';
import styles from './ContactInfoAddress.module.css';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const ContactInfoAddress = observer(function ContactInfoAddress(props) {
  const { address } = props;

  return (
    <Grid component="div" container className={styles.descriptionContainer}>
      <Grid component="div" item xs={12} align="left">
        <span className={styles.descriptionLight} data-testid="description">
          {`${address.Street || ''} ${address.City || ''} ${address.State || ''} ${
            address.ZIP || ''
          }`.trim()}
        </span>
      </Grid>
    </Grid>
  );
});
ContactInfoAddress.whyDidYouRender = true;
ContactInfoAddress.displayName = 'ContactInfoAddress';

export default ContactInfoAddress;
